import { render, staticRenderFns } from "./InventoryItemsList.vue?vue&type=template&id=1cf0b7d6&"
import script from "./InventoryItemsList.vue?vue&type=script&lang=ts&"
export * from "./InventoryItemsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports